import { useCallback, useState } from 'react'

export interface StackItem<T> {
  id: string
  value: T
}

export interface StackHandler<T> {
  current: T | undefined
  set: (value: T) => () => void
}

export const useStackHandler = <T>(): StackHandler<T> => {
  const [stackItems, setStackItems] = useState<Array<StackItem<T>>>([])

  const set = useCallback((value: T) => {
    const id = Math.random().toString(36).substring(2, 15)
    setStackItems((prev) => [...prev, { id, value }])
    return () => setStackItems((prev) => prev.filter((bg) => bg.id !== id))
  }, [])

  const current = stackItems.length > 0 ? stackItems[stackItems.length - 1].value : undefined

  return {
    current,
    set,
  }
}
